import React from "react";
import ActividadPersonas from "../images/actividadpersonas.png";
import Policia from "../images/policia.png";
import PersonasNota from "../images/personasnota.png";
import Salud from "../images/salud.png";
import Posta from "../images/posta.png";
import Enfermera from "../images/enfermera.png";
import FondoMuni from "../images/fondomuni.png";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
    },
  },
  actividadFondo: {
    backgroundImage: "url(" + FondoMuni + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    minHeight: 500,
    width: "100%",
    marginTop: 40,
    textAlign: "right",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    "& p": {
      lineHeight: 1.5,
      maxWidth: 400,
    },
    marginBottom: "4em",
  },
  actividad: {
    background: "#6a2c9138",
    border: "6px solid " + theme.palette.purple.main,
    "& p": {
      marginLeft: "1em",
    },
    marginBottom: "4em",
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& li": {
      textAlign: "left",
    },
    "& h1": {
      textAlign: "left",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
    },
  },
}));

const Lamina2 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 5: Las personas que nos cuidan"
        meta={[
          {
            property: "og:title",
            content: "Lámina 5: Las personas que nos cuidan",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "En las localidades existen instituciones que brindan a la población servicios de salud, seguridad, entre otros.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="5" color="primary" />
      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={2}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={8} md={8} xs={12}>
            <Title title="Las personas que nos cuidan" color="primary" />
            <p>
              En las localidades existen instituciones que brindan a la
              población servicios de salud, seguridad, entre otros.
            </p>
          </Grid>
          <Grid item lg={4} md={4} xs={12}>
            <img src={Policia} style={{ maxWidth: 350 }} alt="Policia" />
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="primary" />
        <p>
          <strong>
            Une con una línea las imágenes y las instituciones con las que se
            relacionan.
          </strong>
        </p>
        <img
          src={ActividadPersonas}
          style={{ maxWidth: 860 }}
          alt="Actividad personas"
        />
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={2}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={5} md={5} xs={12}>
            <Actividad color="primary" />
            <p>
              <strong>Responde de manera escrita o verbal:</strong>
            </p>
            <ul>
              <li>¿Qué instituciones hay en tu localidad?</li>
              <li>¿De qué se encargan?</li>
              <li>¿Por qué es importante su labor?</li>
            </ul>
          </Grid>
          <Grid item lg={7} md={7} xs={12}>
            <img src={PersonasNota} alt="Nota" />
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <TitleSmall title="EL SISTEMA DE SALUD" color="primary" />
        <Grid
          container
          className={classes.root}
          spacing={2}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} xs={12}>
            <p>
              Los puestos de salud, las postas médicas, los hospitales y las
              clínicas son las instituciones encargadas de darnos asistencia
              médica. Acudimos a ellas para los chequeos de rutina, para las
              vacunas, para tratar alguna enfermedad o en caso de accidentes y
              emergencias. En ellas laboran el personal médico, de enfermería y
              otros trabajadores cuya misión es velar por nuestra salud.
            </p>
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <img src={Salud} alt="Nota" />
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <img src={Posta} alt="Nota" />
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <p style={{ color: "#ec008c" }}>
              <strong>
                En situaciones como la actual, los médicos, las enfermeras y los
                trabajadores del sector salud se han convertido en verdaderos
                héroes, pues, además de su trabajo regular, ahora son los
                principales encargados de atender a las personas infectadas por
                el coronavirus y se exponen a ser contagiados.
              </strong>
            </p>
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <p style={{ color: "#3d3d98" }}>
              <strong>
                Su trabajo es muy importante, ya que en nuestro país el sistema
                de salud tiene mucho por mejorar en cuanto a cobertura,
                equipamiento y calidad de los servicios. Eso es algo en lo que
                las autoridades tendrán que trabajar en los próximos años.
              </strong>
            </p>
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <img src={Enfermera} alt="Nota" />
          </Grid>
        </Grid>
        <Actividad color="primary" />
        <p>
          <strong>Imagina a una doctora o a un enfermero.</strong>Escribe un
          párrafo o graba un audio o un video en el que le agradezcas y resaltes
          la importancia de su labor en el contexto actual.
        </p>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/06/Ciudadanía-Activa-Lámina-5.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          color="primary"
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 5: Las personas que nos cuidan'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="Mi localidad"
        anteriorEnlace="/lamina-1-4"
        siguiente="Perú, un territorio muy diverso"
        siguienteEnlace="/lamina-1-6"
      />
    </>
  );
};

export default Lamina2;
